/**
 * An object used to get page information from the server
 */
export class Page {
    // The number of elements in the page
    pageSize = 10;
    // The total number of elements
    totalElements = 0;
    // The total number of pages
    totalPages = 0;
    // The current page number
    pageNumber = 1;
    // The current sort
    sorts = [{prop: 'Id', dir: 'asc'}];
    // The current sort as string
    get sortAsString() {
        if (this.sorts !== undefined && this.sorts.length > 0) {
            return this.sorts[0]['prop'] + ' ' + this.sorts[0]['dir'];
        }
    }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-entity/model/page.ts